import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { ActionModal } from "@components";
import { Routes } from "@utils";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description?: string | React.ReactNode;
  onRetry?: () => void;
}

export const ActionRetryModal: React.FC<Props> = ({
  isOpen,
  onClose,
  title,
  description,
  onRetry,
}) => {
  const navigate = useNavigate();

  const handleVolverAlInicio = useCallback(() => {
    onClose();
    navigate(Routes.SOLICITUDES);
  }, [onClose, navigate]);

  const handleRetry = useCallback(() => {
    onClose();
    onRetry?.();
  }, [onClose, onRetry]);

  return (
    <ActionModal
      isOpen={isOpen}
      onClose={handleRetry}
      title={title}
      description={description}
      secondaryButton={{
        label: "Volver al inicio",
        onClick: handleVolverAlInicio,
      }}
      primaryButton={{
        label: "Reintentar",
        onClick: handleRetry,
      }}
    />
  );
};
